import CallRequestsNotificationsContainer from './call-requests-notifications-container';

export default CallRequestsNotificationsContainer;
